import * as React from "react";
import { useSelector } from "react-redux";
import { matchPath, useLocation, useNavigate } from "react-router";
import { profileCompletionFlags } from "../assets/interface/primeSharkWebsite_interface";
import { useState } from "react";
import {
  ACCOUNT_TYPE,
  LOGIN_TYPE,
  SUBSCRIPTION_BUY_MODE,
} from "../assets/constants/constants";
import ConfirmSubscriptionModal from "../components/Login/Subscription/BuySubscriptionApprovalModal";

export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: React.JSX.Element;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
}: ProtectedRouteProps) {
  const location = useLocation();
  const pathname = location.pathname;

  const activeLoginTypes = useSelector(
    (state: any) => state?.items?.storeActiveLoginType,
  );
  let account_type = activeLoginTypes?.account_type;
  let login_type = activeLoginTypes?.loginType;
  const [loader, setLoader] = useState(false);
  const [notCount, setNoteCount] = useState(0);
  const storeProfileCompletion: profileCompletionFlags = useSelector(
    (state: any) => state?.items?.profileCompletionFlags,
  );
  let {
    has_investment_profile_completed,
    has_investment_subscription,
    has_want_to_sell_subscription,
    has_want_to_sell_profile_completed,
    has_want_to_grow_subscription,
    has_want_to_grow_profile_completed,
    has_active_subscription,
    has_free_subscription,
    has_investment_free_subscription,
    has_want_to_grow_subs,
    has_investor_free_subscription,
    has_investor_profile_completed,
    has_investor_subscription,
    has_subscription_expired,
    has_want_to_grow_free_subscription,

    has_investor_subs,
    has_investment_subs,
    has_want_to_sell_subs,
    has_want_to_sell_free_subscription,
  } = storeProfileCompletion;

  const [modalMessage, setModalMessage] = useState("");
  const [subscriptionMode, setSubscriptionMode] = useState("");
  const [showModal, setShowModal] = useState(false);

  const isAuthenticated = !!localStorage.getItem("access_token");

  const restrictedRoutesForInvestorCard = [
    `entrepreneur/want_to_grow/investors/:id`,
  ];
  const restrictedRoutesForGlobalConnectCard = [`/global-connect/:id`];
  const chatsRoutes = [
    `/global-connect/:id`,
    `/entrepreneur/want_to_grow/chats/:id`,
    `/entrepreneur/investment/chats/:id`,
    `/investor/chats/:id`,
  ];

  const chatsRoutesinvestor = [`/investor/chats/:id`];

  const getUpgradeMessage = (
    targetPlan: "Capital Bridge" | "Global Connect" | "paid plan",
  ) => {
    const isCapitalBridgeUser = Boolean(has_investment_subs || has_investor_subs);
    const isBusinessExchangeUser = Boolean(has_want_to_sell_subs);
    const isGlobalConnectUser = Boolean(has_want_to_grow_subs);
    const hasPaidPlan =
      isCapitalBridgeUser || isBusinessExchangeUser || isGlobalConnectUser;

    if (hasPaidPlan) {
      if (targetPlan === "Global Connect") {
        if (isCapitalBridgeUser) {
          return `As a Capital Bridge user, this feature is not part of your current plan. Upgrade to Global Connect to access this feature.`;
        }
        if (isBusinessExchangeUser) {
          return `As a Business Exchange user, this feature is not part of your current plan. Upgrade to Global Connect to access this feature.`;
        }
      } else if (targetPlan === "Capital Bridge") {
        if (isGlobalConnectUser) {
          return `As a Global Connect user, this feature is not part of your current plan. Upgrade to Capital Bridge to access this feature.`;
        }
        if (isBusinessExchangeUser) {
          return `As a Business Exchange user, this feature is not part of your current plan. Upgrade to Capital Bridge to access this feature.`;
        }
      }
      return `This feature is not part of your current paid plan. Upgrade to ${targetPlan === "paid plan" ? "a paid plan" : targetPlan} to access this feature.`;
    }

    if (!has_active_subscription) {
      return `You don't have any subscription plan! Buy ${targetPlan === "paid plan" ? "a paid plan" : `a ${targetPlan} paid plan`} to access this feature and enjoy additional benefits.`;
    }

    return `You’re currently on a free plan, Upgrade to ${targetPlan === "paid plan" ? "a paid plan" : `a ${targetPlan} paid plan`} to access this feature and enjoy additional benefits.`;
  };

  const checkSubscriptionStatus = () => {
    const isAllowed =
      localStorage.getItem("is_investor_profile_verified") === "VERIFIED";
    const isCapitalBridgeProfileRejected =
      localStorage.getItem("is_investment_profile_verified") === "REJECTED";
    const isGlobalConnectProfileRejected =
      localStorage.getItem("is_want_to_grow_profile_verified") === "REJECTED";
    const isBusinessExchangeProfileRejected =
      localStorage.getItem("is_want_to_sell_profile_verified") === "REJECTED";
    const isInvestorProfileRejected =
      localStorage.getItem("is_investor_profile_verified") === "REJECTED";

    if (
      isInvestorProfileRejected &&
      login_type?.toLowerCase() === LOGIN_TYPE.INVESTOR?.toLocaleLowerCase() &&
      pathname !== "/investor/profile-rejected" &&
      pathname !== "/investor/my-profile"
    ) {
      return { flag: false, msg: "INVESTOR_REJECTED" };
    }

    const isInvestorUnderReviewRouteAllowed = (path: string) => {
      return (
        path === "/investor/home" ||
        path === "/investor/my-profile" ||
        path === "/investor/profile-review" ||
        path === "/profile-under-review" ||
        path === "/my-sessions" ||
        path.startsWith("/my-sessions") ||
        path.startsWith("/session/") ||
        path.startsWith("/investor-forum") ||
        path.startsWith("/investor/investor-forum") ||
        path.startsWith("/network-hub") ||
        path.startsWith("/investor/network-hub") ||
        path.startsWith("/mentor/mentor-connect") ||
        path.startsWith("/investor/mentor-connect") ||
        path.startsWith("/guest/mentor-connect") ||
        path === "/investor/trusted-mentors" ||
        path.startsWith("/investor/trusted-mentors/")
      );
    };

    if (
      login_type?.toLowerCase() === LOGIN_TYPE.INVESTOR?.toLocaleLowerCase() &&
      !isAllowed &&
      !isInvestorProfileRejected &&
      !isInvestorUnderReviewRouteAllowed(pathname)
    ) {
      return { flag: false, msg: "INVESTOR_LOGIN" };
    } else if (
      login_type?.toLowerCase() === LOGIN_TYPE.ENTREPRENEUR?.toLowerCase()
    ) {
      if (
        account_type?.toLowerCase() ===
        ACCOUNT_TYPE.INVESTMENT?.toLocaleLowerCase() &&
        isCapitalBridgeProfileRejected &&
        pathname !== "/entrepreneur/investment/my-profile" &&
        pathname !== "/entrepreneur/want-to-grow/my-profile" &&
        pathname !== "/profile-rejected"
      ) {
        return { flag: false, msg: "ENTREPRENEUR_PROFILE_REJECTED" };
      } else if (
        account_type?.toLowerCase() === "want-to-sell" &&
        isBusinessExchangeProfileRejected &&
        pathname !== "/entrepreneur/want-to-sell/my-profile" &&
        pathname !== "/entrepreneur/want-to-grow/my-profile" &&
        pathname !== "/profile-rejected"
      ) {
        return { flag: false, msg: "ENTREPRENEUR_PROFILE_REJECTED" };
      } else if (
        account_type?.toLowerCase() === "want-to-grow" &&
        isBusinessExchangeProfileRejected &&
        pathname !== "/entrepreneur/want-to-grow/my-profile" &&
        pathname !== "/entrepreneur/want-to-sell/my-profile" &&
        pathname !== "/entrepreneur/investment/my-profile" &&
        pathname !== "/profile-rejected"
      ) {
        return { flag: false, msg: "ENTREPRENEUR_PROFILE_REJECTED" };
      }
    }
    if (
      !has_investment_subs &&
      !has_want_to_sell_subs &&
      restrictedRoutesForInvestorCard.some((route) =>
        matchPath({ path: route, end: true }, pathname),
      )
    ) {
      return { flag: false, msg: getUpgradeMessage("Capital Bridge") };
    }

    if (
      !has_want_to_grow_subs &&
      restrictedRoutesForGlobalConnectCard.some((route) =>
        matchPath({ path: route, end: true }, pathname),
      )
    ) {
      return { flag: false, msg: getUpgradeMessage("Global Connect") };
    }
    // Investors bypass the chat-access upgrade gate — chats (including mentor
    // threads opened from MySessions) are accessible to them regardless of
    // subscription state. Matches the MentorConnect bypass.
    const isInvestor =
      login_type?.toLowerCase() === LOGIN_TYPE.INVESTOR?.toLowerCase();
    if (
      !isInvestor &&
      !has_want_to_grow_subs &&
      !has_want_to_sell_subs &&
      !has_investment_subs &&
      !has_investor_subs &&
      !has_investor_free_subscription &&
      chatsRoutes.some((route) =>
        matchPath({ path: route, end: true }, pathname),
      )
    ) {
      return { flag: false, msg: getUpgradeMessage("paid plan") };
    }

    return { flag: true };
  };

  let navigate = useNavigate();
  const handleYes = () => {
    navigate(
      `/${login_type?.toLowerCase()}/${account_type?.toLowerCase()}/subscriptions?mode=${subscriptionMode}`,
    );
  };
  React.useEffect(() => {
    if (!isAuthenticated) {
      navigate(-1);
      return;
    }

    // Mandatory first-login password change (admin-created users) takes
    // absolute priority — before the profile-review / rejected / subscription
    // redirects below.
    if (
      localStorage.getItem("force_password_change") === "1" &&
      pathname !== "/change-password"
    ) {
      navigate("/change-password", { replace: true });
      return;
    }

    const result: any = checkSubscriptionStatus();
    if (!result.flag && result.msg === "INVESTOR_REJECTED") {
      navigate("/profile-rejected", { replace: true });
      return;
    } else if (!result.flag && result.msg === "INVESTOR_LOGIN") {
      navigate("/profile-under-review", { replace: true });
      return;
    } else if (!result.flag && result.msg === "ENTREPRENEUR_PROFILE_REJECTED") {
      navigate("/profile-rejected", { replace: true });
      return;
    } else if (!result.flag) {
      setSubscriptionMode(SUBSCRIPTION_BUY_MODE.NEW);
      setModalMessage(result.msg);
      setShowModal(true);
    }
  }, [
    isAuthenticated,
    pathname,
    has_investment_subs,
    has_want_to_sell_subs,
    has_want_to_grow_subs,
    navigate,
  ]);

  if (showModal) {
    return (
      <ConfirmSubscriptionModal
        show={showModal}
        message={modalMessage}
        onConfirm={handleYes}
        onCancel={() => {
          setShowModal(false);
          navigate(-1);
        }}
      />
    );
  }

  return outlet;
}
